import Vue from 'vue';

import commonScripts from './partials/common';
import validators from './partials/helpers/vueValidators';

commonScripts();

new Vue({
	el: '#contactForm',
	delimiters: ['${', '}'],
	mixins: [validators],
	data: {
		isSending: false,
		error: '',
		fields: {
			firstName: '',
			lastName: '',
			email: '',
			name: '',
			message: ''
		},
		errors: {
			firstName: false,
			lastName: false,
			email: false,
			name: false,
			message: false
		},
		required: ['firstName', 'email']
	},
	methods: {
		send() {
			for (const key in this.fields) {
				this.errors[key] = (!this.fields[key] && this.errors[key] != null && this.required.indexOf(key) != -1) ? 'To pole jest wymagane' : false;
			}

			for (const error in this.errors) {
				if (this.errors[error] != false) return;
			}

			this.isSending = true;

			setTimeout(() => {
				this.$el.submit()
			}, 500);
		}
	}
});
